import { render, staticRenderFns } from "./BackgroundTaskItem.vue?vue&type=template&id=355c585b&scoped=true"
import script from "./BackgroundTaskItem.vue?vue&type=script&lang=js"
export * from "./BackgroundTaskItem.vue?vue&type=script&lang=js"
import style0 from "./BackgroundTaskItem.vue?vue&type=style&index=0&id=355c585b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "355c585b",
  null
  
)

export default component.exports